import { InputField, Spinner } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import {
	Container,
	ErrorText,
	ItemContainer,
	Subtitle,
} from './NewPassword.styles';
import { InputCode } from '../shared/components/InputCode';
import React from 'react';
import { useNewPassword } from './NewPassword.hooks';

export const NewPassword = (): JSX.Element => {
	const {
		code,
		password,
		confirmPassword,
		isLoading,
		hasErrorRegex,
		hasError,
		errorMessage,
		handleResendCode,
		setCode,
		setPassword,
		setConfirmPassword,
		handleSubmit,
	} = useNewPassword();

	return (
		<Container>
			<Subtitle>
				Introduzca el código recibido en el correo electrónico
			</Subtitle>
			<ItemContainer variant>
				<InputCode
					resendCodeVisible
					error={hasError && !code}
					length={6}
					label=""
					loading={false}
					onComplete={(code: any) => setCode(code)}
					onResendCode={handleResendCode}
				/>
				{hasError && !code && (
					<ErrorText>El código de validación no puede estar</ErrorText>
				)}
			</ItemContainer>
			<ItemContainer>
				<InputField
					id="password"
					placeholder="Nueva contraseña"
					className="login-password-new"
					type="password"
					value={password}
					error={hasError}
					onChange={(value) => setPassword(value)}
				/>
				{hasError && errorMessage && <ErrorText>{errorMessage}</ErrorText>}
			</ItemContainer>
			<ItemContainer>
				<InputField
					id="confirmPassword"
					placeholder="Confirma tu contraseña"
					className="login-password-new"
					type="password"
					value={confirmPassword}
					onChange={(value) => setConfirmPassword(value)}
					error={hasErrorRegex}
				/>
				{hasErrorRegex && (
					<ErrorText>
						La contraseña debe tener al menos 8 caracteres, una mayúscula, una
						minúscula, un número y un caracter especial. Caracteres disponibles
						^ $ * . [ ] {} ( ) ? {`"`} ! @ # % & / \{` , > < ' : ;`} | _ ~ ` = +
						-
					</ErrorText>
				)}
			</ItemContainer>
			<Button onClick={handleSubmit} disabled={isLoading}>
				{isLoading ? <Spinner size="24px" color="#fff" /> : 'Confirmar'}
			</Button>
		</Container>
	);
};
